import { Parcel } from "../../../../services/parcelTypes";
import { formatCurrency, formatNumber } from "../../../../utils/parcelFormatters";
import { Field } from "../ParcelFields";
import { ParcelSection } from "../ParcelSection";

export function ParcelValuationSection({
    parcel,
}: {
    parcel: Parcel;
}) {
    return (
        <ParcelSection
            title="Valuation"
            columns={3}
            icon={
                <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
            }
            collapsible
            defaultExpanded={false}
        >
            <Field label="Tax Year" value={formatNumber(parcel.valuation?.taxYear)} />
            <Field label="Assessed Land" value={formatCurrency(parcel.valuation?.appraised?.land)} />
            <Field label="Assessed Improvements" value={formatCurrency(parcel.valuation?.appraised?.improvements)} />
            <Field label="Assessed Total" value={formatCurrency(parcel.valuation?.appraised?.total)} />
            <Field label="Taxable Land" value={formatCurrency(parcel.valuation?.taxable?.land)} />
            <Field label="Taxable Improvements" value={formatCurrency(parcel.valuation?.taxable?.improvements)} />
            <Field label="Taxable Total" value={formatCurrency(parcel.valuation?.taxable?.total)} />
        </ParcelSection>
    );
}